import { render } from "./module-copy-to-page-dialog.vue?vue&type=template&id=5ee0e598"
import script from "./module-copy-to-page-dialog.vue?vue&type=script&lang=js"
export * from "./module-copy-to-page-dialog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__